module.exports = __webpack_public_path__ + "img/white-right-arrow.d9afed85.svg";